import React from 'react'
import moment from 'moment'
import RecordSection from './_RecordSection'
import InfoLine from './_InfoLine'
import { View } from '@react-pdf/renderer'

const IncidentDetails = ({ epcr, anonymised }) => {
  // Server-frozen snapshots include subcontractors, who never resolve through
  // the employee populate; fall back to populate for older records
  const staffInvolvedRecords = (epcr.incident.staffInvolvedRecords || []).filter(
    (x) => x?.name
  )
  const staffInvolvedArray =
    staffInvolvedRecords.length > 0
      ? staffInvolvedRecords.map((x) =>
          [
            x.name,
            x.clinicalRole && `(${x.clinicalRole})`,
            x.personType === 'Subcontractor' && '[Subcontractor]',
          ]
            .filter(Boolean)
            .join(' ')
        )
      : epcr.incident.staffInvolved.map(
          (x) =>
            `${x.userAccount?.firstName} ${x.userAccount?.lastName} (${x.clinicalRole})`
        )

  const vehiclesInvolvedArray = epcr.incident.incidentVehicles.map(
    (x) => x.callSign
  )

  if (anonymised) {
    return (
      <RecordSection title="Incident Details">
        <InfoLine
          label="Reported Complaint"
          value={epcr.incident.reportedComplaint}
        />
      </RecordSection>
    )
  }
  return (
    <RecordSection title="Incident Details">
      <InfoLine
        label="Incident Date"
        value={moment(epcr.incident.incidentDate).format('DD.MM.YYYY HH:mm')}
      />
      <InfoLine
        label="Event"
        value={epcr.incident?.linkedEvent?.title}
        hideIfEmpty
      />
      <InfoLine
        label="Incident Location"
        value={epcr.incident.incidentLocation}
      />
      <InfoLine label="Staff Involved" value={staffInvolvedArray.join(', ')} />
      <InfoLine
        label="Vehicles Involved"
        value={vehiclesInvolvedArray.join(', ')}
        hideIfEmpty
      />
      <InfoLine label="Incident Type" value={epcr.incident.incidentType} />
      <InfoLine
        label="Occurred at Event"
        value={
          epcr.incident.incidentType === 'Event'
            ? epcr.incident.injuryOccurredAtEvent
            : undefined
        }
        hideIfEmpty
      />
      <InfoLine
        label="Reported By"
        value={epcr.incident.reportedBy}
        hideIfEmpty
      />
      <InfoLine
        label="Reported Complaint"
        value={epcr.incident.reportedComplaint}
      />
      <View
        style={{
          flexDirection: 'row',
          flexWrap: 'wrap',
          columnGap: 4,
          width: '100%',
          display: 'flex',
        }}
      >
        <InfoLine
          label="Call Time"
          value={
            epcr?.incident?.callTime
              ? moment(epcr.incident.callTime).format('HH:mm')
              : '-'
          }
        />
        <InfoLine
          label="Dispatched"
          value={
            epcr?.incident?.dispatchTime
              ? moment(epcr.incident.dispatchTime).format('HH:mm')
              : '-'
          }
        />
        <InfoLine
          label="At Scene"
          value={
            epcr?.incident?.atSceneTime
              ? moment(epcr.incident.atSceneTime).format('HH:mm')
              : '-'
          }
        />
        <InfoLine
          label="Patient Side"
          value={
            epcr?.incident?.patientSideTime
              ? moment(epcr.incident.patientSideTime).format('HH:mm')
              : '-'
          }
        />
        <InfoLine
          label="Leave Scene"
          value={
            epcr?.incident?.leaveSceneTime
              ? moment(epcr.incident.leaveSceneTime).format('HH:mm')
              : '-'
          }
        />
        <InfoLine
          label="At Hospital"
          value={
            epcr?.incident?.arriveHospitalTime
              ? moment(epcr.incident.arriveHospitalTime).format('HH:mm')
              : '-'
          }
        />
        <InfoLine
          label="Patient Handover"
          value={
            epcr?.incident?.patientHandoverTime
              ? moment(epcr.incident.patientHandoverTime).format('HH:mm')
              : '-'
          }
        />
        <InfoLine
          label="Clear"
          value={
            epcr?.incident?.clearTime
              ? moment(epcr.incident.clearTime).format('HH:mm')
              : '-'
          }
        />
      </View>
    </RecordSection>
  )
}

export default IncidentDetails
